import { hasPermission, hasPermissions } from '../utils/authUtils';

export const permissionPlugin = {
  install(app) {
    app.config.globalProperties.$hasPermissions = hasPermissions;
    app.config.globalProperties.$hasPermission = hasPermission;
  },
};
